import { Loc, Type, Dom, Runtime } from "main.core";
import { BitrixVue } from "ui.vue";
import { VSCore } from "vsbx.core";
import { VSDefaultModuleControllerDataProvider } from "vsbx.vsdefaultdataprovider";

export class VSCart {
  constructor(arParams) {
    let selfVSCart = this;
    if (!arParams.selectorBtnCart) arParams.selectorBtnCart = "#btn_basket";
    selfVSCart.arParams = arParams;

    this.name = "VSCart";
    this.node = document.querySelector(arParams.selector);
    VSCore.CONTROL.registerControl(this);
    this.control = VSCore.CONTROL.add(this.node, {
      events: {
        show: () => {
          VSCore.utilURL.removeLocationHash();
          VSCore.utilURL.setHashUrl({
            openCart: "Y",
          });
        },
        hide: () => {
          VSCore.utilURL.removeLocationHash();
        },
      },
    });
    if (VSCore.utilURL.getHashUrl("openCart") == "Y") {
      this.openCart();
    }

    this.provider = new VSDefaultModuleControllerDataProvider(this.node, {
      name: "VSCartProvider",
      controllerName: "vsbx:cart.VSCart",
    });
    let nameApp = "cartApp";
    if (arParams.type) {
      nameApp += arParams.type;
    }

    VSCartAppData.type = arParams.type;

    if (typeof arParams.path != "undefined") VSCartAppData.path = arParams.path;

    VSCartAppData.ELEMENTS_IDS = [];
    for (let i = 0, len = VSCartAppData.ELEMENTS.length; i < len; i++) {
      VSCartAppData.ELEMENTS_IDS.push(VSCartAppData.ELEMENTS[i].ID);
    }
    VSCartAppData.ELEMENTS_BTN_TEXTS = [];
    VSCartAppData.DATA.DELIVERY_PRICE = 0;
    const app = BitrixVue.createApp({
      //el: this.node,
      data() {
        return VSCartAppData;
      },
      methods: {
        changeItemCount: function (id, qty, $event) {
          qty = selfVSCart.normalizeQty(qty);
          if (qty < 1) {
            this.removeItemById(id, $event);
          } else {
            this.updateItemQty(id, qty);
          }
        },
        updateItemQty: function (id, qty) {
          let self = this;
          selfVSCart.provider.run(
            "updateItemQty",
            { id: id, qty: qty, SITE_ID: VSCartAppData.SITE_ID },
            function (d) {
              self.updateItemInModel(d.data);
            }
          );
        },
        updateItemInModel: function (data) {
          this.ELEMENTS = data.ELEMENTS_IN_CART.ELEMENTS;
          this.recalcTotalPrice();
        },
        removeItemById: function (id, $event) {
          let self = this;
          selfVSCart.provider.run(
            "removeItemById",
            { id: id, SITE_ID: VSCartAppData.SITE_ID },
            function (data) {
              for (var i = 0, len = self.ELEMENTS.length - 1; i <= len; i++) {
                if (self.ELEMENTS[i].CART_ITEM_ID == data.REMOVED_ITEM_ID) {
                  self.findAndEnable(app.ELEMENTS[i].ID);
                  self.ELEMENTS.splice(i, 1);
                  self.ELEMENTS_IDS.splice(i, 1);
                  self.recalcTotalPrice();
                  break;
                }
              }
              self.changeAddBtn();
            }
          );
        },
        removeAllItems: function () {
          let self = this;
          selfVSCart.provider.run(
            "removeAllItems",
            { SITE_ID: VSCartAppData.SITE_ID },
            function (d) {
              self.ELEMENTS = [];
              self.enableAllBtn();
              self.ELEMENTS_IDS = [];
            }
          );
        },
        recalcTotalPrice: function () {
          let totalPrice = 0;
          let totalDiscountPrice = 0;
          for (let i = 0, len = VSCartAppData.ELEMENTS.length - 1; i <= len; i++) {
            totalPrice += VSCartAppData.ELEMENTS[i].PRICE * 100 * VSCartAppData.ELEMENTS[i].QTY;
            if (VSCartAppData.ELEMENTS[i].OLD_PRICE)
              totalDiscountPrice +=
                (VSCartAppData.ELEMENTS[i].OLD_PRICE * 1 - VSCartAppData.ELEMENTS[i].PRICE) *
                100 *
                VSCartAppData.ELEMENTS[i].QTY;
          }
          VSCartAppData.DATA.TOTAL_SUM = VS.VSCore.formatRUB(totalPrice / 100);
          VSCartAppData.DATA.TOTAL_DISCOUNT_SUM = VS.VSCore.formatRUB(totalDiscountPrice / 100);
        },
        hideBlock: function () {
          Dom.hide(this.$el);
        },
        changeAddBtn: function () {
          if (selfVSCart.basketCounterNode) {
            selfVSCart.basketCounterNode.innerHTML = VSCartAppData.ELEMENTS.length;
          }
          if (
            VSCartAppData.changeAddToCartBtnText == "N" ||
            VSCartAppData.inCartBtnText.length == 0
          )
            return;
          let elements = document.querySelectorAll(".btn-add-cart");
          for (let i = 0, len = elements.length; i < len; i++) {
            let ID = elements[i].dataset.elementId;
            if (this.ELEMENTS_IDS.indexOf(ID) != -1) {
              this.changeAddBtnHandler(ID);
            }
          }
          
        },
        changeAddBtnHandler: function (id) {
          if (
            VSCartAppData.changeAddToCartBtnText == "N" ||
            VSCartAppData.inCartBtnText.length == 0
          )
            return;
          let btn = this.findBtnById(id);
          if (btn.length == 0) return;
          let params = selfVSCart.getCartParams(btn);
          let elements = this.findElementsInCart(id);
          for (let i = 0, len = elements.length; i < len; i++) {
            let elementParams = JSON.stringify(elements[i].PARAMS);
            if (elementParams == "[]") elementParams = "{}";
            if (elementParams == JSON.stringify(params)) {
              this.disableBtn(id, btn);
              break;
            } else {
              this.enableBtn(id, btn);
            }
          }
        },
        disableBtn: function (ID, obj) {
          this.ELEMENTS_BTN_TEXTS[ID] = obj[0].innerHTML;
          for (let i = 0, l = obj.length; i < l; i++) {
            obj[i].innerHTML = VSCartAppData.inCartBtnText;
            Dom.addClass(obj[i], "product-buy-link_in-cart");
          }
        },
        enableBtn: function (ID, obj) {
          if (typeof this.ELEMENTS_BTN_TEXTS[ID] == "undefined") return;
          for (let i = 0, l = obj.length; i < l; i++) {
            obj[i].innerHTML = this.ELEMENTS_BTN_TEXTS[ID];
            Dom.removeClass(obj[i], "product-buy-link_in-cart");
          }
        },
        enableAllBtn: function () {
          for (var i = 0, len = this.ELEMENTS_IDS.length; i < len; i++) {
            this.findAndEnable(this.ELEMENTS_IDS[i]);
          }
        },
        findAndEnable: function (id) {
          var btn = this.findBtnById(id);
          if (btn.length == 0) return;
          this.enableBtn(id, btn);
        },
        findElementsInCart: function (id) {
          let elements = [];
          for (let i = 0, len = this.ELEMENTS.length; i < len; i++) {
            if (this.ELEMENTS[i].ID == id) elements.push(this.ELEMENTS[i]);
          }
          return elements;
        },
        findBtnById: function (id) {
          return document.querySelectorAll(
            ".btn-add-cart[data-element-id=" + id + "]"
          );
        },
        // emptyParamsValue: function (params) {
        //   if (params){
        //     for (let i in params) {
        //       if (typeof params[i] == "undefined") params[i] = "";
        //     }
        //   }

        //   return params;
        // },
        formatPlural: function (n) {
          return this.forms_plural[
            n % 10 == 1 && n % 100 != 11
              ? 0
              : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
              ? 1
              : 2
          ];
        },
        makeOrder: () => {},
      },
    });
    VSCartAppData[nameApp] = this;
    
    this.vueApp = app.mount(this.node);
    // if (window.frameCacheVars !== undefined) {
    //   BX.addCustomEvent("onFrameDataReceived", function (json) {
    //     selfVSCart.vsCartInit();
    //   });
    // } else {
    //   BX.ready(function () {
    //     selfVSCart.vsCartInit();
    //   });
    // }
    selfVSCart.vsCartInit();
  }
  normalizeQty(qty) {
    return !isNaN(qty) && qty > 0 ? qty : 1;
  }
  bcAnimateAdditionToCart(btn, addElement) {
    if (typeof VSCartAppData.effectAfterAdd == "undefined") return;
    switch (VSCartAppData.effectAfterAdd) {
      case "fly":
        if (this.nodeBtnCart) VSCore.moveToElement(btn, this.nodeBtnCart);
        break;
      case "notification":
        Runtime.loadExtension("ui.notification").then((exports) => {
          BX.UI.Notification.Center.notify({
            content: Loc.getMessage("VS_CART_ADD_BASKET", {
              "#NAME_ELEMENT#": addElement.NAME,
            }),
            autoHideDelay: 4000,
          });
        });
        break;
      case "show":
        this.openCart();
        break;
    }
  }
  openCart() {
    if (this.control) {
      this.control.show();
    }
  }
  closeCart() {
    if (this.control) {
      this.control.hide();
    }
  }
  getCartParams(btn) {
    let params = {};
    let f = VSCore.getFunction("vsCartGetParams");
    if (Type.isFunction(f)) params = f(btn);
    return params;
  }
  vsCartInit() {
    let self = this;
    let getInputCount = (target) => {
      let parent = BX.findParent(target, { className: "product-buy-block" });
      if (parent) {
        return parent.querySelector("input[name=product_count]");
      }
      return false;
    };
    let addItemToCart = function () {
      let target = BX.proxy_context;
      if (!Dom.hasClass(target, "product-buy-link_in-cart")) {
        let id = target.dataset.elementId,
          qty,
          params = {},
          inputCount;

        inputCount = getInputCount(target);
        if (inputCount) qty = parseFloat(inputCount.value);
        params = self.getCartParams(target);

        qty = self.normalizeQty(qty);
        self.provider.run(
          "addItemToCart",
          { id: id, qty: qty, params: params, SITE_ID: VSCartAppData.SITE_ID },
          function (data) {
            VSCartAppData.ELEMENTS = data.data.ELEMENTS;
            VSCartAppData.ELEMENTS_IDS = [];
            let addElement;
            for (var i = 0, len = data.data.ELEMENTS.length; i < len; i++) {
              VSCartAppData.ELEMENTS_IDS.push(data.data.ELEMENTS[i].ID);
              if (data.data.ELEMENTS[i].ID == id)
                addElement = data.data.ELEMENTS[i];
            }
            self.bcAnimateAdditionToCart(target, addElement);
            self.vueApp.recalcTotalPrice.call(self.vueApp);
            self.vueApp.changeAddBtn.call(self.vueApp);
          }
        );
      }
    };
    BX.bindDelegate(
      document,
      "click",
      { className: "btn-add-cart" },
      BX.proxy(addItemToCart, self)
    );
    let countDown = function () {
      let target = BX.proxy_context,
        inputCount = getInputCount(target);
      let qty = parseInt(inputCount.value);
      qty = self.normalizeQty(qty);
      qty--;
      if (qty < 1) {
        qty = 1;
      }
      inputCount.value = qty;
    };
    BX.bindDelegate(
      document,
      "click",
      { className: "product-count-spinner__item--down" },
      BX.proxy(countDown, self)
    );
    let countUp = function () {
      let target = BX.proxy_context,
        inputCount = getInputCount(target);
      let qty = parseInt(inputCount.value);
      qty = self.normalizeQty(qty);
      qty++;
      if (qty < 1) {
        qty = 1;
      }
      inputCount.value = qty;
    };
    BX.bindDelegate(
      document,
      "click",
      { className: "product-count-spinner__item--up" },
      BX.proxy(countUp, self)
    );
    if (self.arParams.selectorBtnCart)
      self.nodeBtnCart = document.querySelector(self.arParams.selectorBtnCart);
    if (self.nodeBtnCart) {
      self.basketCounterNode =
        self.nodeBtnCart.querySelector(".basket-counter");
      BX.bind(self.nodeBtnCart, "click", BX.proxy(self.openCart, self));
    }

    self.vueApp.changeAddBtn.call(self.vueApp);
  }
}
